export default __webpack_public_path__ + "static/O0113-6716caf54f1c615d18ba1389fec9128c.png";